module.exports = {"id":"dp3_3l1q3","text":"Copyright and licences","instructions":"AI-generated content should be labelled to:","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.3","questionType":"PickOne","random":true,"options":[{"id":"dp3_3l1q3-a1","text":"Show its origin and limits","score":1.8},{"id":"dp3_3l1q3-a2","text":"Increase search visibility","score":0},{"id":"dp3_3l1q3-a3","text":"Avoid ownership questions","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.3/l1q3.json
// module id = 1157
// module chunks = 41